import React from "react";

export default function VoiceWave({ active, color = "#FBBF24" }) {
  const heights = [0.4, 0.7, 1.0, 0.7, 0.4];
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 3, height: 20 }}>
      <style>{`
        @keyframes vwave { from{transform:scaleY(0.3)} to{transform:scaleY(1)} }
      `}</style>
      {heights.map((h, i) => (
        <div key={i} style={{
          width: 3, borderRadius: 3, background: color,
          height: active ? `${h * 18}px` : "3px",
          animation: active ? `vwave 0.5s ease-in-out ${i * 0.1}s infinite alternate` : "none",
          transition: "height 0.3s ease",
        }} />
      ))}
    </div>
  );
}
